export const getRequestsKeys = (fromDate, toDate) => [
  `requests`,
  fromDate,
  toDate,
];
export const getDashboardQueryKeys = (
  fromDate,
  toDate,
  onlySelectedPeriod = false
) => ['dashboard', fromDate, toDate, onlySelectedPeriod];
